import store from '@/store';

export const userCanByRole = (role: string): boolean => {
  return store.getters.userCan(role);
};
